import { useState } from 'react';
import { isPlainObject, isUndefined, omitBy } from 'lodash';
import param from 'jquery-param';
import { decamelizeKeys } from 'humps';
import moment from 'moment';
import { authenticatedFetch } from '../lib/authenticatedFetch.js';

export const useFetchFile = () => {
  const [loading, setLoading] = useState(false);

  const downloadBlob = async (
    apiUrl,
    url,
    query,
    fileNameSuffix,
    fileExtension,
    method,
    body
  ) => {
    setLoading(true);
    try {
      let endpoint = url;

      if (query && typeof query !== 'undefined') {
        if (!isPlainObject(query)) {
          throw new Error('Expected query to be an object.');
        }
        endpoint += `?${param(decamelizeKeys(omitBy(query, isUndefined)))}`;
      }

      const apiRoot = `${apiUrl}/api/v1/`;
      const fullUrl =
        endpoint.indexOf(apiRoot) === -1 ? apiRoot + endpoint : endpoint;

      const requestOptions = {
        method: method || 'GET',
        headers: {
          Accept: 'application/json',
        },
        body,
      };

      // Use authenticatedFetch to handle 419/401/403 automatically
      const res = await authenticatedFetch(fullUrl, requestOptions, apiUrl);

      // Handle remaining error statuses
      if (res.status >= 500) {
        throw new Error('Server error. Please try again later.');
      }

      if (!res.ok) {
        const errorText = await res.text();
        throw new Error(errorText || 'Download failed');
      }

      // Success - convert to blob and download
      const blob = await res.blob();
      const href = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      const fileName = `${moment(new Date()).format('MM-DD-YYYY')}-${fileNameSuffix}.${fileExtension}`;

      link.href = href;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(href);
    } catch (error) {
      console.error('Download failed', error);
      return Promise.reject({ Error: 'Something Went Wrong', error });
    } finally {
      setLoading(false);
    }
  };

  return { loading, downloadBlob };
};
